import { MapActions, MapState } from 'context/Map/types';
import { createContext, Dispatch } from 'react';

export const MapContext = createContext<[MapState, Dispatch<MapActions>] | undefined>(undefined);
